import { type Method, type Service } from '../types';
import { AccessTrap } from './AccessTrap';
import { EventEmitter } from './EventEmitter';

type InstantlyReadyEndpoint = {
  endpoint?: Method | Service;
  trap: AccessTrap;
};

export class EndpointsContainer extends EventEmitter {
  private readonly endpoints = new Map<string, InstantlyReadyEndpoint>();

  constructor() {
    super();
    this.endpoints.set('on', {
      endpoint: this.on.bind(this),
      trap: new AccessTrap()
    });
    this.endpoints.set('emit', {
      endpoint: this.emit.bind(this),
      trap: new AccessTrap()
    });
    this.endpoints.set('unsubscribeEvent', {
      endpoint: this.unsubscribeEvent.bind(this),
      trap: new AccessTrap()
    });
    this.endpoints.set('unsubscribeAllEvents', {
      endpoint: this.unsubscribeAllEvents.bind(this),
      trap: new AccessTrap()
    });
  }

  get(key: string) {
    const entry = this.endpoints.get(key);

    if (!entry) {
      return;
    }

    if (entry?.endpoint !== undefined) {
      return entry.endpoint;
    }

    return entry.trap.serializer as Method | Service;
  }

  set(key: string, value?: Method | Service) {
    const entry = this.endpoints.get(key);

    if (!entry) {
      this.endpoints.set(key, {
        endpoint: value,
        trap: new AccessTrap()
      });

      return true;
    }

    if (value) {
      entry.endpoint = value;
      entry.trap.deserialize(value);
    }

    return true;
  }

  delete(key: string) {
    const entry = this.endpoints.get(key);

    if (!entry) {
      return;
    }

    entry.endpoint = undefined;
  }
}
